/**
 * Gallery template container - render list of images with template
 * input parameters:
 * el - parent container where images displayed
 * options:
 *  - imageClassName:  class name for each button - 'gallery-image' is default
 *  - onImageSelected: callback when button is clicked - return  image id
 *  - imageType: identifies which url  to be displayed: Large, Review etc
 *  - dragable: tells if image can be dragged
 */

import { clearElement } from '../utils';

class TemplatedGallery {

	constructor(el, options = {}) {

		this.options = options;
		this.el = el;
		this.imageClassName = options.imageClassName || 'gallery-image';
		this.onImageSelected = options.onImageSelected || function () { };
		this.onImageLiked = options.onImageLiked || function () { };
		this.imageType = options.imageType || 'Review';
		this.draggable = options.dragable;
		this.isPortraitSkin = options.portraitSkin,
		this.faveIconOn = options.favImgIconOn || null;
		this.faveIconOff = options.favImgIconOff || null;

		if (options.images) {
			this.loadImages(options.images);
		}
	}

	//====  hightlight the currently selected image =====
	highlightSelectedimage(elt) {

		let images = this.el.querySelectorAll('.img-wrap');
		images.forEach(img =>{
			img.classList.remove("selected");
		});
		elt.classList.add("selected");
	}

	setCustomImgClass(customImg){
		if(customImg){
			this.el.classList.add('custom');
		} else {
			this.el.classList.remove('custom');
		}
	}

	loadImages(images) {
		clearElement(this.el);

		if (this.options.portraitSkin) {
			this.el.classList.add('vertical');
		}

		const length = this.options.maxSize ? Math.min(options.maxSize, images.length) : images.length;
		const isPortrait = this.options.portraitSkin;
		let imagesloaded = 0;

		for (const image of images) {

			const img = new Image();
			img.setAttribute('role', 'button');
			img.setAttribute('tabIndex', 0);
			img.setAttribute('id', image.Id);
			img.setAttribute('data-image-locked', image.Locked);
			img.setAttribute('data-price', image.PriceCode);
			img.classList.add(this.imageClassName);

			if(image.CatId === 1) img.classList.add("custom-image");

			if(image.tallARatio){
				img.classList.add("tallImage");
			}

			if (this.draggable) {
				img.setAttribute('draggable', true);
				img.addEventListener('dragstart', e => {
					const data = {
						id: e.target.id,
						url: e.target.src
					};
					e.dataTransfer.setData('text', JSON.stringify(data));
				});
			}

			const imageUrl = (this.imageType === 'Large') ? image.LargeImage : image.ReviewImage || image.LargeImage;
			img.src = imageUrl;

			this.el.appendChild(img);

			////////////////  Apply Wrapper  //////////////////////

			// create wrapper container ---------------------------
			let wrapper = document.createElement('div');
			wrapper.className = 'img-wrap';
			
			if (image.Name) {
				img.setAttribute('alt', image.Name);
				wrapper.title = image.Name;
			}
			
			// insert wrapper before el in the DOM tree
			img.parentNode.insertBefore(wrapper, img);
			// move el into wrapper
			wrapper.appendChild(img);

			// Events on wrapper div, not img element
			wrapper.addEventListener('click', e => {
				this.highlightSelectedimage(e.currentTarget);
				this.onImageSelected(e.currentTarget.children[0].id);
			});

			wrapper.addEventListener('keydown', e => {
				if (e && (e.key === 'Enter' || e.key === ' ')) {
					// trigger by enter or space
					this.onImageSelected(e.currentTarget.children[0].id);
				}
			});

			// add favourite icon/button ---------------------------
			let faveImgBtn = document.createElement('button');
			faveImgBtn.type = "button";
			faveImgBtn.classList.add('fave-image-btn');
			wrapper.appendChild(faveImgBtn);

			if(this.faveIconOff && this.faveIconOn){
				let faveImgIcon = document.createElement('img');
				faveImgIcon.src = image.Liked? this.faveIconOn : this.faveIconOff;
				faveImgBtn.selected = image.Liked;
				faveImgBtn.appendChild(faveImgIcon);
			}

			faveImgBtn.onclick = (evt) => {

				evt.stopPropagation();

				//highlight on-off
				let thisBtn = evt.currentTarget
				thisBtn.selected =  (thisBtn.selected)?  false : true;
				thisBtn.querySelector('img').src = (thisBtn.selected)? this.faveIconOn : this.faveIconOff;

				//fave action 
				let thisImg = thisBtn.parentElement.children[0];
				this.onImageLiked( thisBtn.selected, thisImg.id, thisImg.src, thisImg.attributes['data-image-locked'].value === "true", image );
			}

			//add spacer at bottom of each gallery to clear the toolbar when scrolling. Use CSS to hide/show as necessary --------------------
			imagesloaded++;
			if(imagesloaded == length) {
				let spacer = document.createElement('div');
				spacer.classList.add("safariSpacer");
				this.el.appendChild(spacer);
			}
		}
	};
}

export default TemplatedGallery;